module.exports = __webpack_public_path__ + "img/tj-logo.13095857.png";